import { getChartPalette } from "../theme";
import type { ChartContext } from "./context";

export function buildScatterOption(
  context: ChartContext,
): Record<string, unknown> {
  const { data, isDark, translateNode, unitText, axisText, ct, base } = context;
  const ds = data.datasets[0];
  if (!ds) return base;
  const vals = ds.values as unknown as Array<Record<string, unknown>>;
  const xIsCat = vals.length > 0 && typeof vals[0].x === "string";
  return {
    ...base,
    tooltip: {
      trigger: "axis",
      backgroundColor: ct.bgElevated,
      borderColor: ct.border,
      formatter: (ps: Array<{ value: [string, number]; seriesName: string }>) =>
        ps
          .map((p) => `${translateNode(p.seriesName)}: ${unitText(p.value[1])}`)
          .join("\n"),
    },
    xAxis: {
      type: xIsCat ? "category" : "value",
      data: xIsCat
        ? [
            ...new Set(
              data.datasets.flatMap((s) =>
                (s.values as Array<{ x: string }>).map((v) => v.x),
              ),
            ),
          ]
        : undefined,
      axisLabel: {
        color: ct.secondary,
        ...(xIsCat ? { formatter: translateNode } : {}),
      },
    },
    yAxis: {
      type: "value",
      axisLabel: { color: ct.secondary, formatter: axisText },
      splitLine: { lineStyle: { color: ct.lightBorder } },
    },
    grid: { left: 60, right: 20, bottom: 40, top: 65, containLabel: true },
    series: data.datasets.map((s, i) => ({
      type: "scatter",
      name: s.label,
      data: xIsCat
        ? (s.values as unknown as Array<{ x: string; y: number }>).map((v) => [
            v.x,
            v.y,
          ])
        : (s.values as unknown as Array<{ x: number; y: number }>).map((v) => [
            v.x,
            v.y,
          ]),
      itemStyle: {
        color: getChartPalette(isDark, data.datasets.length)[i],
      },
    })),
  };
}
